/**
 * oauth.ts — the listing autofill extension's own OAuth identity (BR-2, BR-28).
 *
 * Browser-safe (no dependencies): read by the API (client registration, consent, grants, token
 * middleware), the landlord app (Connected Apps) and the extension (authorize request), so the
 * scope, client id and the consent capability copy are never redeclared.
 *
 * The scope is deliberately NOT part of the MCP scope catalog (apps/api/src/services/mcp/mcp.scopes.ts):
 * an MCP client can never register for or request it.
 */
/** The only OAuth scope the extension client is registered for and its tokens carry. */
export const LISTING_EXTENSION_SCOPE = 'listing-extension';
/** The extension's pre-registered (ADMIN_CREATED) OAuth client id. */
export const LISTING_EXTENSION_CLIENT_ID = 'resida-listing-extension';
/**
 * The extension's privacy policy, on the public site (docs/policies/listing-extension-privacy-policy.md,
 * served by apps/web). Linked from the consent screen (the client's policy URI) and the side panel, and
 * given to the Chrome Web Store listing. One URL for every environment: the policy does not vary.
 */
export const LISTING_EXTENSION_PRIVACY_POLICY_URL = 'https://resida.me/privacy-policy/listing-extension';
/** BR-28: what connecting the extension lets it do, and what it cannot do — the single source of the copy. */
export const LISTING_EXTENSION_CAPABILITIES = {
    can: [
        'See your active listings, including their details and photos',
        'Record where you post a listing, so Resida can remind you to take it down',
        "Report problems filling a site's form",
    ],
    cannot: ['Post anything for you', "Use Resida's AI assistant tools"],
};
//# sourceMappingURL=oauth.js.map